import React from 'react';
import PropTypes from 'prop-types';

export default class RegisterStepInlineWarning extends React.PureComponent {

	static propTypes = {
		warning: PropTypes.string
	};

	render() {
		let { warning } = this.props;
		return (
			<div style={{color: '#FFA604', fontSize: 18}} className={'inline-warning col-lg-12 padding-bottom-40'}>
				<i className={'fa fa-exclamation-triangle'}/> {warning}
			</div>
		);
	}
}
